module.exports = __webpack_public_path__ + "media/application/images/IKG-logo-3d8254d6c9dc5cb75beabc6979ceef6b.svg";